import React, { useState, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import moment from "jalali-moment";
import { toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";

// import JS files
import MuiModal from "../../shares/MuiModal";
import CreateOrderCard from "../../shares/CreateOrderCard";
import RingNumbersEdit from "../../shares/RingNumbersEdit";
import { fixNumbers } from "../../../utils";
import MuiDatePicker from "../../shares/MuiDatePicker";
import MuiButtonRef from "../../shares/MuiButtonRef";
import MuiTextField from "../../shares/MuiTextField";
import MuiButton from "../../shares/MuiButton";
import useFetch from "../../../context/useFetch";

// import Others files

const AddItemModal = (props) => {
  let windowWidth = window.screen.width;
  const [ringCode, setRingCode] = useState(undefined);
  const [enterBtn, setEnterBtn] = useState(false);
  const [ringsList, setRingsList] = useState({ results: [] });
  const [nums, setNums] = useState(new Array(6).fill(""));
  const [userSelectedRing, setUserSelectedRing] = useState(undefined);
  const [dateValue, setDateValue] = useState(moment());

  const GetRingsApi = useFetch({
    method: "get",
    url: "Bangle_Service",
    params: {
      code: fixNumbers(ringCode),
    },

    trigger: false,
    setter: setRingsList,
    argFunc: (res) => {
      if (res.results.length <= 0) {
        toast.error("النگویی با کد موردنظر یافت نشد!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const handleSearch = () => {
    setEnterBtn(true);
    GetRingsApi.reFetch();
  };

  const addItemApi = useFetch({
    method: "post",
    url: "Order_Service/add_item_to_order",
    data: userSelectedRing,
    argFunc: (res) => {
      props.setOrderDetail(null)
      props.getOrderApi.reFetch();
      props.setOpenModal(false);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_nums = (ind, nValue) => {
    let beforeNums = [...nums];
    beforeNums[ind] = fixNumbers(nValue);
    setNums(beforeNums);
  };

  function dateOnChange(date) {
    setDateValue(date);
  }

  const AddRing = () => {
    let before = [...props.item.total];

    if (
      before.some(
        (ri) =>
          ri.bangle.id == ringsList.results[0].id &&
          ri.bangle.gender == ringsList.results[0].gender &&
          ri.bangle.color == ringsList.results[0].color
      )
    ) {
      toast.error("النگو قبلا اضافه شده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setUserSelectedRing({
        creator: props.item.creator,
        bangle: ringsList.results[0]?.id,
        order: props.item.id,
        size_one_num: nums[0] !== "" ? parseInt(nums[0]) : 0,
        size_two_num: nums[1] !== "" ? parseInt(nums[1]) : 0,
        size_three_num: nums[2] !== "" ? parseInt(nums[2]) : 0,
        size_four_num: nums[3] !== "" ? parseInt(nums[3]) : 0,
        size_five_num: nums[4] !== "" ? parseInt(nums[4]) : 0,
        size_six_num:
          nums[5] !== "" && nums[5] !== undefined ? parseInt(nums[5]) : 0,
        receive_at: moment(dateValue).locale("en").format("YYYY-MM-DD"),
      });
      addItemApi.reFetch();
      // toast.success("النگو موردنظر با موفقیت به سبد خرید اضافه شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    }
  };

  const add_new_ring = () => {
    AddRing();
    if (props.emptySearchData !== undefined) {
      props.empty_search();
    }
    if (props.hasOpenModal != undefined) props.setOpenModal(false);
  };

  const htmlElRef = useRef(null);

  const useFocus = () => {
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };
  const [inputRef, setInputFocus] = useFocus();

  let random_num = Math.random() * 10;
  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-11/12"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 items-center py-4 border-dashed border-b mb-4">
            <span className="mb-2 md:mb-0 text-sm md:text-base">
              کد النگو موردنظر خود را به صورت کامل جستجو کنید.
            </span>
            <div className="mb-2 md:mb-0">
              <MuiTextField
                isLTR={true}
                id="code"
                label="کد النگو"
                variant="outlined"
                size="small"
                onChange={(e) => setRingCode(e.target.value)}
                value={ringCode}
              />
            </div>
            <div className="text-left mt-2 md:mb-0">
              <MuiButton
                onClick={handleSearch}
                variant="contained"
                icon={<SearchIcon />}
                color="primary"
                text="جستجو"
              />
            </div>
          </div>
          {ringsList.results.length > 0 ? (
            <>
              <CreateOrderCard ring={ringsList.results[0]}>
                <div className="md:grid grid-cols-12 gap-x-2 items-center">
                  <div className="md:col-span-9">
                    <RingNumbersEdit
                      item={props.item}
                      dynamicMap
                      nums={nums}
                      update_nums={update_nums}
                      random_num={random_num}
                    />
                  </div>
                  <div className="md:col-span-3 grid grid-cols-2 md:grid-cols-3 mt-4">
                    <div className="md:col-span-2 mr-2 md:mr-0" tabIndex="-1">
                      <MuiDatePicker
                        onChange={dateOnChange}
                        value={dateValue}
                      />
                    </div>
                    <div
                      className="md:col-span-1 text-left mt-1 amin"
                      tabIndex={7 + random_num}
                      onFocus={setInputFocus}
                    >
                      <MuiButtonRef
                        ref={inputRef}
                        onClick={add_new_ring}
                        variant="contained"
                        color="success"
                        text="افزودن"
                        size="small"
                        disabled={nums.every((i) => i == "")}
                      />
                    </div>
                  </div>
                </div>
              </CreateOrderCard>
            </>
          ) : (
            ""
          )}
        </div>
      </MuiModal>
    </>
  );
};

export default AddItemModal;
